import { useMutation } from '@tanstack/react-query';

import { ImportPageData, Platform, PLATFORM_URL_SEGMENT } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';

export const importPage = (data: ImportPageData, platform: Platform): Promise<void> => {
  return axios.post(`/${PLATFORM_URL_SEGMENT[platform]}/pages/import`, data);
};

type ImportPageOptions = {
  platform: Platform;
  config?: MutationConfig<typeof importPage>;
};

export function useImportPage({ config = {}, platform }: ImportPageOptions) {
  return useMutation({
    ...config,
    mutationFn: (vars) => importPage(vars, platform),
    onSuccess: (...vars) => {
      queryClient.invalidateQueries(['pages']);
      if (config.onSuccess) {
        config.onSuccess(...vars);
      }
    },
  });
}
